/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Follow_Pending_CountInputs */

const en_follow_pending_count = /** @type {(inputs: Follow_Pending_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} pending`)
};

const es_follow_pending_count = /** @type {(inputs: Follow_Pending_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} pendientes`)
};

const fr_follow_pending_count = /** @type {(inputs: Follow_Pending_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} en attente`)
};

const de_follow_pending_count = /** @type {(inputs: Follow_Pending_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} ausstehend`)
};

const id_follow_pending_count = /** @type {(inputs: Follow_Pending_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} tertunda`)
};

/** @type {(inputs: Follow_Pending_CountInputs) => LocalizedString} */
const ja_follow_pending_count = en_follow_pending_count;

/** @type {(inputs: Follow_Pending_CountInputs) => LocalizedString} */
const zh_follow_pending_count = en_follow_pending_count;

/** @type {(inputs: Follow_Pending_CountInputs) => LocalizedString} */
const ar_follow_pending_count = en_follow_pending_count;

/** @type {(inputs: Follow_Pending_CountInputs) => LocalizedString} */
const it_follow_pending_count = en_follow_pending_count;

/** @type {(inputs: Follow_Pending_CountInputs) => LocalizedString} */
const ru_follow_pending_count = en_follow_pending_count;

/** @type {(inputs: Follow_Pending_CountInputs) => LocalizedString} */
const pt_follow_pending_count = en_follow_pending_count;

/** @type {(inputs: Follow_Pending_CountInputs) => LocalizedString} */
const ko_follow_pending_count = en_follow_pending_count;

/**
* | output |
* | --- |
* | "{count} pending" |
*
* @param {Follow_Pending_CountInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const follow_pending_count = /** @type {((inputs: Follow_Pending_CountInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Follow_Pending_CountInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_follow_pending_count(inputs)
	if (locale === "es") return es_follow_pending_count(inputs)
	if (locale === "fr") return fr_follow_pending_count(inputs)
	if (locale === "de") return de_follow_pending_count(inputs)
	if (locale === "ja") return ja_follow_pending_count(inputs)
	if (locale === "zh") return zh_follow_pending_count(inputs)
	if (locale === "ar") return ar_follow_pending_count(inputs)
	if (locale === "id") return id_follow_pending_count(inputs)
	if (locale === "it") return it_follow_pending_count(inputs)
	if (locale === "ru") return ru_follow_pending_count(inputs)
	if (locale === "pt") return pt_follow_pending_count(inputs)
	return ko_follow_pending_count(inputs)
});